// extracted by mini-css-extract-plugin
export default {"contenButtons":"BtnAndTable_contenButtons__iYSF-","disabled":"BtnAndTable_disabled__TBj7z"};